import axios from "axios";

export const fetchClientConfig = (setDynamicConfig: any) => {
  const getClientConfig = async (clientName: string) => {
    try {
      const envs = ["dev", "stage", "qa", "perf", "uat"];
      const clientUrlParts: string[] = clientName.split(".");
      const isLocalHost: boolean = clientName.includes("localhost");

      let apiBaseUrl = "";
      if (isLocalHost) {
        apiBaseUrl = "-dev";
      } else if (envs.includes(clientUrlParts[0])) {
        apiBaseUrl = `-${clientUrlParts[0]}`;
      }

      const data: any = await axios.get(
        `https://api${apiBaseUrl}.toorakcapital.info/online-sizer/config/fetch/${clientName}`
      );

      if (!data?.data) return;
      setDynamicConfig((prev: any) => ({
        ...prev,
        ...data?.data,
        supportEmail:
          data?.data.supportEmail ?? "tooraksupport@triconinfotech.com",
      }));
      localStorage.setItem("client_config", JSON.stringify(data?.data));
    } catch (error) {
      console.error("Error fetching client config", error);
    }
  };

  const enteredUrl = window.location.href;
  const parsedUrl = new URL(enteredUrl);
  return getClientConfig(parsedUrl.hostname.replace("www.", ""));
  // eslint-disable-next-line react-hooks/exhaustive-deps
};
